"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _jsxRuntime = require("react/jsx-runtime");

var Segment = function Segment(_ref) {
  var stroke = _ref.stroke,
      strokeDasharray = _ref.strokeDasharray,
      strokeDashoffset = _ref.strokeDashoffset,
      strokeWidth = _ref.strokeWidth,
      title = _ref.title;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
    cx: _constants.center.x,
    cy: _constants.center.y,
    r: _constants.radius,
    fill: "none",
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeDasharray: strokeDasharray,
    strokeDashoffset: strokeDashoffset,
    children: title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    })
  });
};

Segment.propTypes = {
  stroke: _propTypes.default.string.isRequired,
  strokeDasharray: _propTypes.default.string.isRequired,
  strokeDashoffset: _propTypes.default.number.isRequired,
  strokeWidth: _propTypes.default.number,
  title: _propTypes.default.string,
  value: _propTypes.default.number.isRequired
};
Segment.defaultProps = {
  strokeWidth: 5
};
var _default = Segment;
exports.default = _default;
//# sourceMappingURL=index.js.map